import { updateSavedSearch } from 'bundles/connect/helpers/prospect_api';
import type { SavedSearch } from 'bundles/connect/types';
import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap-5';

type Props = {
  savedSearch: SavedSearch | null;
  onHide: () => void;
  onUpdate: (savedSearch: SavedSearch) => void;
}

export default function SavedSearchEditModal({ savedSearch, onHide, onUpdate }: Props) {
  const [name, setName] = useState(savedSearch?.name ?? '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setName(savedSearch?.name ?? '');
  }, [savedSearch]);

  const handleSave = () => {
    if (!savedSearch) return;
    setSaving(true);
    updateSavedSearch(savedSearch.id, name).then((res) => {
      setSaving(false);
      onUpdate(res);
      onHide();
    });
  };

  return (
    <Modal centered show={!!savedSearch} onHide={onHide}>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title>Edit Saved Search</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-2">
          <Form.Label>Name <small className="text-danger">{'(required)'}</small></Form.Label>
          <Form.Control
            maxLength={150}
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={saving} variant="outline-primary" onClick={onHide}>Cancel</Button>
        <Button disabled={saving || !name} variant="secondary" onClick={handleSave}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
